export function init360Viewer() {
    const viewers = document.querySelectorAll('[data-pv-args]');

    viewers.forEach((viewer) => {
        let args = JSON.parse(viewer.dataset.pvArgs);
        console.log(args);
        viewer.addEventListener('click', () => {
            viewer.style.backgroundImage = '';
            viewer.classList.remove('idle')
            viewer = new ProductViewer({
                element: viewer,
                images: args['images']
            })
        })
})
}